module.exports = __webpack_public_path__ + "../public/img/avatar.4f2a6187.png";